import React from 'react'

import { useConfirmationModal } from 'hooks'
import { useJobSeekerModalForm } from './common/hooks'
import { useSelector } from 'react-redux'
import { getLanguage } from 'ducks/auth'

export const useJobSeekerModalState = (state, handlers) => {
  const { candidate, isOpen } = state
  const { onCancel, onClose, onConfirm } = handlers

  const language = useSelector(getLanguage)

  const languages = React.useMemo(() => [language], [language])

  const {
    state: { control, formState, isDirtyOrInvalid },
    handlers: { handleFormReset, handleFormSubmit },
  } = useJobSeekerModalForm({ candidate, languages, isOpen }, { onConfirm })

  const {
    handleConfirmationClose,
    handleConfirmationConfirm,
    handleConfirmationOpen,
    isConfirmationOpen,
  } = useConfirmationModal(() => {
    handleFormReset()
    onClose()
  })

  const handleCancel = React.useCallback(() => {
    isDirtyOrInvalid ? handleConfirmationOpen() : onCancel()
  }, [isDirtyOrInvalid, handleConfirmationOpen, onCancel])

  const handleClose = React.useCallback(() => {
    isDirtyOrInvalid ? handleConfirmationOpen() : onClose()
  }, [isDirtyOrInvalid, handleConfirmationOpen, onClose])

  const handleConfirm = React.useCallback(handleFormSubmit, [handleFormSubmit])

  return {
    state: {
      form: { control, formState },
      languages,
      isConfirmationOpen,
    },
    handlers: {
      handleCancel,
      handleClose,
      handleConfirm,
      handleConfirmationClose,
      handleConfirmationConfirm,
    },
  }
}
